/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { reverseFilterMappings } from 'embercom/lib/reporting/flexible/reverse-filter-mappings';

export default class ConversationReportController extends Controller {
  @service intercomEventService;
  @service reportingService;
  @service reportSubscriptionService;
  @service store;
  @service appService;

  teammateId = null;
  tag = null;
  teamOrTeammate = null;
  subscriptionId = null;
  source = null;

  queryParams = ['subscriptionId', 'source'];

  get app() {
    return this.appService.app;
  }

  get dashboardName() {
    return 'Conversations';
  }

  get reverseFilterMappings() {
    return reverseFilterMappings(this);
  }

  get customAttributeIds() {
    return this.conversationAttributeDescriptors.map((descriptor) => descriptor.id);
  }

  get shouldDisplayIntroBanner() {
    return (
      this.app.canUseFeature('conversation_attributes') &&
      this.conversationAttributeDescriptors.length === 0
    );
  }

  @action
  updateRange(range) {
    this.reportingService.updateRange(range);

    let params = {
      action: 'filtered_by_date',
      object: this.reportName,
      date_filter: this.range.selectedRange,
      start_date: range.startMoment.format('YYYY/MM/DD'),
      end_date: range.endMoment.format('YYYY/MM/DD'),
    };

    let teamOrTeammate = this.teamOrTeammate;
    if (teamOrTeammate) {
      params.models = [teamOrTeammate];
    }
    this.intercomEventService.trackAnalyticsEvent(params);
    this.clearReportSubscription();
  }

  @action
  filterBarSelectionChanged(filterType, filterValues, operator) {
    this.clearReportSubscription();
    //backwards compatible with existing teammate filters before the filter bar was introduced
    if (filterType === 'teammatesParticipated') {
      this.set('teammateId', filterValues);
    } else if (this.customAttributeIds.includes(filterType)) {
      this.customAttributes.updateValues(filterType, filterValues, operator);
      this.set('customAttributes', this.customAttributes.clone());
    } else {
      this.set(filterType, filterValues);
    }
  }

  @action
  filterBarCleared() {
    this.clearReportSubscription();
  }

  @action
  trackPageView() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: this.reportName,
    });
    this.trackReportSubscriptionEmailLinkClick();
  }

  trackReportSubscriptionEmailLinkClick() {
    if (this.source === 'subscriptionEmail') {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'clicked',
        object: 'report_subscription_email_link',
      });
    }
  }

  clearReportSubscription() {
    this.reportSubscriptionService.resetSubscription();
    this.set('subscriptionId', null);
    this.set('source', null);
  }
}
